import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Entrepreneur from "../../entity/user/Entrepreneur";

const SERVICE = "service-user";
const ENTITY = "entrepreneurs";

export default function () {
    const {findOneBy, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Entrepreneur(data);

    return {
        findOneById(id) {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "entrepreneur");
                }
            }
        }
    }
}